import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { pick } from '../../../foundation/utils/object.utils';
import { BaseTableTD } from '../../common/BaseTable';
import Checkbox from '../Checkbox/Checkbox';
import { ControlledActions } from './ControlledActions';
import { MAP_TD_ALIGN } from './ControlledRows.contants';
import { ControlledTableRowRoot } from './ControlledRows.styled';
// Component.
// -----------------------------------------------------------------------------
export const ControlledRows = ({ actions, borderType, columns, dataRowId, enableRowSelection, onChangeOne, rows, size }) => (_jsx(_Fragment, { children: rows.map((row, index) => {
        const rowId = typeof dataRowId === 'function'
            ? dataRowId(row.original)
            : pick(row, dataRowId);
        return (_jsxs(ControlledTableRowRoot, { isSelected: row.isSelected, children: [enableRowSelection && (_jsx(BaseTableTD, { size: size, type: "icon", children: _jsx(Checkbox, { checked: row.isSelected, name: `tr-check-${rowId}`, label: "", onChange: () => onChangeOne(row) }) })), row.columns.map((cell, j) => {
                    const { align, type, className, render } = columns[j];
                    return (_jsx(BaseTableTD, { align: align ?? MAP_TD_ALIGN[type], size: size, type: type, className: className, children: typeof render === 'function'
                            ? render(row.original)
                            : pick(row.original, render) }, `td-${rowId}-${j}`));
                }), actions && (_jsx(ControlledActions, { actions: actions, borderType: borderType, row: row, size: size }))] }, `tbody-tr-${rowId || index}`));
    }) }));
//# sourceMappingURL=ControlledRows.js.map